import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { 
    selectUserTypes,
    selectPermissions,
    selectIsCreateUserType,
    setIsCreateUserType,
    selectUserTypeTemplate,
    putUserType,
    getUserTypes,
    setUserTypesArray
} from '../../../store/delegationOfAuthoritySlice';
import {
    selectRole
} from '../../../store/pageLayoutSlice';
import ViewUserType from '../ViewUserType/ViewUserType';
import './UserTypes.css';
import { apiCall } from '../../../APICalls/APICalls';
import { deepCopy } from '../../../store/quotesAndNotificationsSlice';

function UserTypes(props){

    const userTypesArray = useSelector( selectUserTypes );
    const permissionsArray = useSelector( selectPermissions );
    const adminUserRole = useSelector( selectRole );
    const isCreateUserType = useSelector( selectIsCreateUserType );
    const createUserType = useSelector( selectUserTypeTemplate );

    const dispatch = useDispatch();

    function updateUserTypesArray(newUserType, isCreate){
        const newUserTypesArray = deepCopy( userTypesArray );
        if( !isCreate ){
            const newUserTypesIndex = newUserTypesArray.findIndex( newType => newType.userType === newUserType.userType );
            if( newUserTypesIndex !== -1 ){
                newUserTypesArray[ newUserTypesIndex ] = newUserType;
                dispatch( setUserTypesArray(newUserTypesArray) );
            }
        } else {
            newUserTypesArray.unshift( newUserType );
            dispatch( setUserTypesArray(newUserTypesArray) );
            console.log("made it");
        }
    }

    const userTypes = userTypesArray.map((userType, i) => {
        return (
            <div className="view_user_type_container_div" key={i}> 
                <ViewUserType
                    userType={ userType }
                    adminUserRole={ adminUserRole }
                    permissionsArray={ permissionsArray }
                    saveUserType={ (userType) => dispatch( putUserType( userType ) ) }
                    getUserTypes={ () => dispatch( getUserTypes({app: 'hdmi'}) ) }
                    updateUserTypes={ (newUserType, isCreate) => updateUserTypesArray(newUserType, isCreate) }
                />
            </div>
        );
    });

    return (
        <div id="delegation_of_authority_container">
            {
                isCreateUserType &&
                <div className="view_user_type_container_div" > 
                    <ViewUserType
                        userType={ createUserType }
                        adminUserRole={ adminUserRole }
                        permissionsArray={ permissionsArray }
                        isCreateUserType={ isCreateUserType }
                        cancelCreate={ () => dispatch( setIsCreateUserType( false ) ) }
                        saveUserType={ (userType) => dispatch( putUserType( userType ) ) }
                        getUserTypes={ () => dispatch( getUserTypes({app: 'hdmi'}) ) }
                        updateUserTypes={ (newUserType, isCreate) => updateUserTypesArray(newUserType, isCreate) }
                    />
                </div>
            }
            { userTypes }
        </div>
    );
}

export default UserTypes;